import { defineStore } from "pinia";
import { LoggedInUser } from '@/types/user'

export const useAuthStore = defineStore('authStore', {
    state: () => ({
        loggedIn: false,
        loggedInUser: {} as LoggedInUser,
        config: {},
        targetUrl: '',
        lpiUser: false,
        offline: false
    })
})